import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPpsisUpdates } from '../actions';
import { getIsFetching, getUpdatePpsis } from '../selectors';

const useUpdatesPpsis = () => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const updatePpsis = useSelector(getUpdatePpsis);

  useEffect(() => {
    dispatch(fetchPpsisUpdates());
  }, [dispatch]);

  return [isFetching, updatePpsis];
};

export default useUpdatesPpsis;
